export default __webpack_public_path__ + "static/media/icon_dashboard.9f3c7059.svg";